export type GameDataTab = 'pitchers' | 'hitters' | 'games';

export enum GDPlayerSelectorMode {
  Pitcher = 'pitcher',
  Hitter = 'hitter',
  Player = 'player',
}
